import React from 'react'

import { PlusOutlined } from '@ant-design/icons'
import ListPageHeader from '@shared/ListPageHeader'
import ImportTemplatesList from '@shared/import_templates/ImportTemplatesList'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { importTemplateService } from '@services/admin/importTemplateService'

export default function AdminImportTemplatesList() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['data', 'data.import_templates']}
        actions={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/import_templates/new')}
          >
            {t('common.button.new')}
          </Button>
        }
      />
      <ImportTemplatesList
        service={importTemplateService}
        role="admin"
      />
    </div>
  )
}
